import { h } from 'preact';
import SVGWrapper from '../../SvgWrapper';

function PreviousIcon({ height = 60, width = 60, color = 'white' }) {
  return (
    <SVGWrapper
      width={width}
      height={height}
      viewBox="0 0 24 24"
    >
      <clipPath id="clip_previous_icon"><path d="m0 0h24v24h-24z" /></clipPath>
      <g clipPath="url(#clip_previous_icon)" fill={color}>
        <path d="m4.125 6.00007v12.00003h1.35v-12.00003z" />
        <path d="m18.6 6.7093c0-.61057-.6926-.96753-1.1939-.61904-1.2027.83596-3.0827 2.11389-4.5318 2.96681-1.4315.84256-3.41769 1.84563-4.76927 2.50943-.58124.2854-.56467 1.1333.02694 1.3966 1.35016.6008 3.31833 1.5038 4.74233 2.2725 1.4565.7862 3.3527 1.9783 4.555 2.7518.5033.3237 1.1707-.0355 1.1707-.6339z" />
      </g>
    </SVGWrapper>
  );
}

export default PreviousIcon;
